import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Divider,
} from "@mui/material";

function SeqIntel() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const initialMode = currentPath.includes("mutalytics")
    ? "mutalytics"
    : "nucleoread";
  const [mode, setMode] = React.useState(initialMode);

  const handleSwitch = (event, newMode) => {
    if (newMode) {
      setMode(newMode);
      navigate(`/seqintel/${newMode}`);
    }
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: 4,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
      }}
    >
      {/* LEFT SIDEBAR */}
      <Box
        sx={{
          flex: { xs: "1 1 auto", md: "0 0 340px" },
          position: { md: "sticky" },
          top: 24,
          alignSelf: "flex-start",
          borderRadius: 1,
          backdropFilter: "blur(14px)",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.7), rgba(255,255,255,0.35))",
          //   boxShadow: "0 20px 40px rgba(30,58,138,0.18)",
          p: 3,
          overflow: "hidden",
        }}
      >
        {/* Accent strip */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 6,
            background: "linear-gradient(180deg, #1e3a8a, #3b82f6)",
          }}
        />

        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 1,
            background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: 1,
          }}
        >
          SeqIntel
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
          AI-powered sequence intelligence suite
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <ToggleButtonGroup
          orientation="vertical"
          value={mode}
          exclusive
          onChange={handleSwitch}
          fullWidth
          sx={{
            gap: 1.5,
            "& .MuiToggleButton-root": {
              borderRadius: 2,
              justifyContent: "flex-start",
              px: 3,
              py: 1.6,
              textTransform: "none",
              fontWeight: 600,
              color: "#1e3a8a",
              background: "rgba(255,255,255,0.6)",
              boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
              transition: "all 0.25s ease",
              "&:hover": {
                transform: "translateX(6px)",
                background: "rgba(59,130,246,0.08)",
              },
              "&.Mui-selected": {
                background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
                color: "#fff",
                boxShadow: "0 10px 20px rgba(59,130,246,0.45)",
                transform: "translateX(8px)",
              },
            },
          }}
        >
          <ToggleButton value="nucleoread">🧬 Nucleo Read</ToggleButton>
          <ToggleButton value="mutalytics">🧪 Mutalytics</ToggleButton>
        </ToggleButtonGroup>

        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            {mode === "nucleoread" ? "Nucleo Read" : "Mutalytics"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {mode === "nucleoread"
              ? "Decode nucleotide sequences into primers, translations, and functional insights."
              : "Rapid mutation triage to prioritize protein variants before simulation."}
          </Typography>
        </Box>
      </Box>

      {/* RIGHT CONTENT */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default SeqIntel;
